import { alpha } from '@instructure/ui-color-utils';
var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    entryWrapperPadding: spacing.xSmall,
    focusBorderColor: colors.brand,
    focusOutlineColor: alpha(colors.brand, 50),
    userResponsePaddingLeft: spacing.small,
    previewBoxColor: colors.ash,
    previewBoxBorderWidth: borders.widthSmall,
    fileIconColor: colors.slate,
    spinnerColor: colors.porcelain,
    removeButtonMargin: spacing.small
  };
};
export default generateComponentTheme;